import axios from "./axiosinstance";

const BugApi = {

  createBug: (data) =>
    axios.post(
      "/bugs",
      data,
    ),

  getProjectBugs: (
    projectId,
  ) =>
    axios.get(
      `/bugs/project/${projectId}`,
    ),

  getAssignedBugs: () =>
    axios.get(
      "/bugs/assigned",
    ),

  startBugWork: (id) =>
    axios.put(
      `/bugs/${id}/start`,
    ),

  fixBug: (id) =>
    axios.put(
      `/bugs/${id}/fix`,
    ),

  closeBug: (id) =>
    axios.put(
      `/bugs/${id}/close`,
    ),

  reopenBug: (id) =>
    axios.put(
      `/bugs/${id}/reopen`,
    ),

  approveProject: (
    projectId,
  ) =>
    axios.put(
      `/bugs/project/${projectId}/approve`,
    ),

};

export default BugApi;